export default "__VITE_ASSET__DmVeP8bo__"